import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import {NavLink} from 'react-router-dom';
import {styled} from '@mui/material/styles';
import {theme} from '../../styles.js';

const StyledNavLink = styled(NavLink)({
  color: 'inherit',
  textDecoration: 'none',
  '&:not(:last-child)': {
    marginRight: theme.spacing(3),
  },
  '&.active': {
    color: theme.palette.primary.main,
  },
});

const NavItem = ({children, ...props}) => (
  <StyledNavLink exact {...props}>
    <Typography color="inherit">{children}</Typography>
  </StyledNavLink>
);

NavItem.propTypes = {
  children: PropTypes.node,
};

export default NavItem;
